import React from "react";
import { CellContentType, RowType } from "./types";

export function DateColumnFormatter(
  cellContent: CellContentType,
  row: RowType
) {
  return <span>{new Date(row.createDate).toLocaleString("fa-IR")}</span>;
}
